import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthSessionContext } from '@context/AuthContext'
import { usePathHistoryContext } from '@context/PathHistoryContext'

import { Body1, Heading3, Heading4, Title1 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { Link } from '@ui/components/Link'

import { useDispatchOpenChat } from '@hooks/useDispatchOpenChat'

import { NotFoundGraphic } from '@assets/graphics/NotFound.graphic'

import { BackButton } from '@shared/components/BackButton'

import styles from './NotFound.module.scss'

export const PageNotFound: React.FC = () => {
  const { navigateToPreviousPath } = usePathHistoryContext()
  const { t } = useTranslation()
  const [auth] = useContext(AuthSessionContext)
  const { dispatchOpenChat, isLoading } = useDispatchOpenChat()

  return (
    <div className={styles.wrapper}>
      <div>
        <div className='is-flex is-link mb-2' onClick={() => navigateToPreviousPath()}>
          <BackButton fillColor='text-info-med-em' />
          <Body1>{t('Go back')}</Body1>
        </div>
        <Heading3 isParagraph className={styles.title} semibold>
          404
        </Heading3>
        <Heading4 className='my-4'>{t('errors.Something went wrong')}</Heading4>
        <Title1 className='text-secondary'>
          {t('errors.The page maybe broken, or the link may have been removed.')}
        </Title1>
        {!auth && (
          <div className='mt-4'>
            <span>
              <Link size='lg' to='/sign-up'>
                {t('Sign-up')}
              </Link>
            </span>
            <span className='mx-2 '>{t('or')}</span>
            <span>
              <Link size={'lg'} to='/login'>
                {t('Login')}
              </Link>
            </span>
          </div>
        )}

        <div className='is-flex mt-4'>
          <span className='mr-1'>{t('Having an issue?')}</span>
          <span>
            <Button.Ghost onClick={dispatchOpenChat} loading={isLoading}>
              {t('Contact us')}
            </Button.Ghost>
          </span>
        </div>
      </div>
      <div className='is-flex is-justify-content-center is-align-items-center ml-3'>
        <NotFoundGraphic />
      </div>
    </div>
  )
}
